import { ParsedUrlQuery } from 'querystring';

export function replaceSearchParams(url: URL, params: { [key: string]: string | null }) {
  Object.entries(params).forEach(([name, value]) => {
    replaceSearchParam(url.searchParams, name, value);
  });
}

export function replaceSearchParam(
  searchParams: URLSearchParams,
  name: string,
  value?: string | null,
) {
  if (value) {
    searchParams.set(name, value);
  } else {
    searchParams.delete(name);
  }
}

export function lastPathSegment(url: string): string {
  const parts = url.split('/');
  return parts[parts.length - 1];
}

export function getQueryParam(query: ParsedUrlQuery, param: string) {
  const value = query[param];
  if (Array.isArray(value)) {
    return value[0];
  } else {
    return value;
  }
}

/**
 * Returns the query string portion of the given URL.  Empty string if no query string
 *
 * @param url The url to extract the query string from
 * @param includeSeparator If true (default), include the '?' as part of the returned query string
 */
export function getQueryString(url: string, includeSeparator: boolean = true) {
  const queryStringIndex = url.indexOf('?');
  if (queryStringIndex >= 0) {
    return `${includeSeparator ? '?' : ''}${url.slice(queryStringIndex + 1)}`;
  }
  return '';
}
